/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Bot: 'Bot',
        Total: 'Total',
        SponPay: 'SponPay', // 후원수당
        PositionPay: 'PositionPay',
        RecentDetail: 'RecentDetail',
        ShowSales: 'ShowSales',
        SponDetail: 'SponDetail', // 후원수당 발생내역
        SponDetailMore: 'SponDetailMore', // 더 많은 후원수당 발생내역 보기
        PositonPayDetail: 'PositonPayDetail', // 직급내역
        More: 'More',
        TaxS: 'TaxS',
        TaxJ: 'TaxJ',
        Account: 'Account',
        AccountName: 'AccountName',
        SponsorBot: 'SponsorBot',
        SponsorTitle: 'SponsorTitle',
        DateFormat: 'DateFormat',
        BasedTime: 'BasedTime',
        Score: 'Score',
        ScoreFormat: 'ScoreFormat',
        SponsorTotal: 'SponsorTotal',
        OccurBot: 'OccurBot',
        AquPositon: 'AquPositon',     // 취득직급
        OccurDetail: 'OccurDetail',   // 후원수당 발생내역 자세히 보기
        Detail: 'Detail', // 수당내역 보기
        SaleList: 'SaleList',  // 매출조회
        Others: 'Others',     // 타기관 후원수당 발생내역
        HoldPv: 'HoldPv', // 보유 PV
        PositonPayBot: 'PositonPayBot', //'현재 {position}시네요<br>1~15일간 직급내역을 보여드릴게요.',
        PositionDay15: 'PositionDay15',
        PositionDay31: 'PositionDay31',
        MySales: 'MySales', //'내 매출',
        PositionPayMore: 'PositionPayMore', //'더 많은 직급내역 보기',
        ShowSales: 'ShowSales', //'매출보기',
        Income: 'Income', //수당내역',    
        NothingIncome: 'NothingIncome', //수당이 존재하지 않을때    
        NoHuwon: 'NoHuwon', // 최근 N일간 소실적이 없습니다.
        Sales: 'Sales', // 매출
        InvalidGrade: 'InvalidGrade', 
        MastershipHistory: 'MastershipHistory', //직급내역을 확인해보세요
        NoMastershipHistory: 'NoMastershipHistory', //직급내역이 없을때
        BasedTimeMastership: 'BasedTimeMastership', //직급내역 시간 부분
        TitleSales: 'TitleSales',
        LessHuwon: 'LessHuwon', //본인 보유PV가 10,000 PV 이상일 때만 후원수당이 발생합니다.
    },
    tomy:{
        kr: {
            LessHuwon: '본인 보유PV가 10,000 PV 이상일 때만 후원수당이 발생합니다.',
            TitleSales: '이월',
            Bot: '최근 지급된 후원, 직급 각 1개씩 보여 드릴게요. 더 많은 지급 내역은 쇼핑몰을 이용해 주세요.',
            Total: '실수령액',
            SponPay: '후원수당', // 후원수당
            PositionPay: '직급수당',
            RecentDetail: '최근 수당내역 자세히 보기',
            ShowSales: '매출보기',
            SponDetail: '후원수당 발생내역', // 후원수당 발생내역
            SponDetailMore: '더 많은 후원수당 발생내역 보기',
            PositonPayDetail: '직급내역', // 직급내역    
            More: '더 많은 수당내역 보기',
            TaxS: '소득세',
            TaxJ: '주민세',
            Account: '입금계좌',
            AccountName: '계좌 소유주',    
            SponsorBot: '<b>{name}님</b>, 후원수당을 확인해드립니다.',
            SponsorTitle: '후원수당 관련 내역을 확인해보세요.',
            DateFormat: '{date} 기준',
            BasedTime: '{date}시 정산기준',
            BasedTimeMastership: '{date} 정산기준',
            Score: '취득점수',
            ScoreFormat: '{score}점',
            SponsorTotal: '후원수당합계',
            OccurBot: '후원수당 발생내역을 보여드리겠습니다. 정산 시점에 따라 다소 차이가 있을수 있습니다. [후원수당 발생내역 자세히 보기]를 누르면 자세한 내역 확인이 가능합니다.',
            AquPositon: '취득직급',
            OccurDetail: '후원수당 발생내역 자세히 보기',
            Detail: '수당내역 보기',
            SaleList: '매출조회',
            Others: '타기간 후원수당 발생내역',
            HoldPv: '보유 PV',
            PositonPayBot: '현재 {name}님은 {position}입니다.<br>{최근직급내역 발생기간}일간의 직급내역을 확인해보시겠어요?',
            PositionDay15: '현재 {name}님은 {position}입니다.<br>1~15일간의 직급내역을 확인해보시겠어요?',
            PositionDay31: '현재 {name}님은 {position}입니다.<br>16~말일간의 직급내역을 확인해보시겠어요?',
            MySales: '본인 매출',
            PositionPayMore: '더 많은 직급내역 보기',
            ShowSales: '매출보기',
            Income: '수당내역',
            NothingIncome: '최근에 발생한 수당이 없습니다. [더 많은 수당내역 보기] 버튼을 누르면 다른 기간의 내역을 확인하실 수 있어요.',
            NoHuwon: '최근 {n}일간 소실적이 없습니다.',
            Sales: '매출', // 매출
            InvalidGrade: '아쉽게도 이번에는 달성한 직급이 없습니다.',
            MastershipHistory: '직급내역을 확인해보세요.',
            NoMastershipHistory: '직급내역이 존재하지 않습니다.',
        },
        eng: {
            LessHuwon: 'General commission only occurs when your own PV is 10,000 PV higher.',
            TitleSales: 'Forward',
            Bot: 'We will show you the total benefits you have received recently.',
            Total: 'actual amount received',
            DateFormat: 'by {date}',
            BasedTime: 'by {date}:00 AM',
            BasedTimeMastership: 'by {date}',
            SponPay: 'General commission', // 후원수당
            PositionPay: 'Mastership bonus',
            RecentDetail: 'View details of recent commission',
            ShowSales: 'View Sales',
            SponDetail: 'Occurrence history of general commission', // 후원수당 발생내역
            SponDetailMore: 'View details of general commission',
            PositonPayDetail: 'Mastership History', // 직급내역    
            More: 'View addåitional commissions',
            TaxS: 'Income tax',
            TaxJ: 'resident tax',
            Account: 'deposit account',
            AccountName: 'account holder',    
            SponsorBot: '{name}, Check out your general commission.',
            SponsorTitle: 'Please check the details related to the general commission.',
            Score: 'points earned',
            ScoreFormat: '{score}',
            SponsorTotal: 'total',
            OccurBot: 'We will show you the scores and Mastership achieved during the recent settlement of the general commission. If you click [View Details of general commission], you can also check the details.',
            AquPositon: 'acquired Mastership',
            OccurDetail: 'View additional general commission accrual history',
            Detail: 'View commission details',
            SaleList: 'Sales inquiry',
            Others: 'general commission in Other Periods',
            HoldPv: 'holding PV',
            PositonPayBot: 'Currently, {name} is {position}. Would you like to check the Mastership details during the {recent rank history occurrence period}?',
            PositionDay15: 'currently {name} is {position}<br>1st ~ 15t Check out mastership history.?',
            PositionDay31: 'currently {name} is {position}<br>16th ~ last day Check out mastership history?',
            MySales: 'own sales',
            PositionPayMore: 'See more Mastership',
            ShowSales: 'View sales',
            Income: 'commission details',
            NothingIncome: 'There are no recently accrued commissions. If you click the [View more commission details] button, then you can check the details of other periods.',
            NoHuwon: 'Recently, {n}days have not smaller leg.',
            Sales: 'Sales', // 매출
            InvalidGrade: 'Unfortunately, there are no positions achieved.', 
            MastershipHistory: 'Check out your mastership history.',
            NoMastershipHistory: 'You have no mastership history.',

        }
    },
    papa:{
        kr: {
            LessHuwon: '본인 보유PV가 10,000 PV 이상일 때만 후원수당이 발생합니다.',
            TitleSales: '이월',
            Bot: '최근 지급된 후원, 직급 각 1개씩 보여 드릴게요. 더 많은 지급 내역은 쇼핑몰을 이용해 주세요.',
            Total: '실수령액',
            SponPay: '후원수당', // 후원수당
            PositionPay: '직급수당',
            RecentDetail: '최근 수당내역 자세히 보기',
            ShowSales: '매출보기',
            SponDetail: '후원수당 발생내역', // 후원수당 발생내역
            SponDetailMore: '더 많은 후원수당 발생내역 보기',
            PositonPayDetail: '직급내역', // 직급내역    
            More: '더 많은 수당내역 보기',
            TaxS: '소득세',
            TaxJ: '주민세',
            Account: '입금계좌',
            AccountName: '계좌 소유주',    
            SponsorBot: '{name}님의 후원수당이에요.',
            SponsorTitle: '후원수당 관련 내역을 확인해보세요.',
            DateFormat: '{date} 기준',
            BasedTime: '{date}시 정산기준',
            BasedTimeMastership: '{date} 정산기준',
            Score: '취득점수',
            ScoreFormat: '{score}점',
            SponsorTotal: '후원수당합계',
            OccurBot: '후원수당 발생내역을 보여드리겠습니다. 정산 시점에 따라 다소 차이가 있을수 있습니다. [후원수당 발생내역 자세히 보기]를 누르면 자세한 내역 확인이 가능합니다.',
            AquPositon: '취득직급',
            OccurDetail: '후원수당 발생내역 자세히 보기',
            Detail: '수당내역 보기',
            SaleList: '매출조회',
            Others: '타기간 후원수당 발생내역',
            HoldPv: '보유 PV',
            PositonPayBot: '{name}님의 직급은 현재 {position}이네요. $최근 발생한 직급내역 기준일자$의 직급내역을 한번 살펴보세요.',
            PositionDay15: '현재 {name}님은 {position}입니다.<br>1~15일간의 직급내역을 확인해보시겠어요?',
            PositionDay31: '현재 {name}님은 {position}입니다.<br>16~말일간의 직급내역을 확인해보시겠어요?',
            MySales: '본인 매출',
            PositionPayMore: '더 많은 직급내역 보기',
            ShowSales: '매출보기',
            Income: '수당내역',
            NothingIncome: '{name}님, {date} 기준 회원님의 수당이 존재하지 않습니다.',
            NoHuwon: '최근 {n}일간 소실적이 없습니다.',
            Sales: '매출', // 매출
            InvalidGrade: '아쉽게도 이번에는 달성한 직급이 없습니다.', 
            MastershipHistory: '직급내역을 확인해보세요.',
            NoMastershipHistory: '이런, 직급내역이 존재하지 않네요.',

        },
        eng: {
            LessHuwon: 'General commission only occurs when your own PV is 10,000 PV higher.',
            TitleSales: 'Forward',
            Bot: 'Total pay that {name} recently received.',
            Total: 'actual amount received',
            SponPay: 'General commission', // 후원수당
            PositionPay: 'Mastership bonus',
            RecentDetail: 'View details of recent commission',
            ShowSales: 'View Sales',
            SponDetail: 'Occurrence history of general commission', // 후원수당 발생내역
            SponDetailMore: 'View details of general commission',
            PositonPayDetail: 'Mastership History', // 직급내역    
            More: 'View addåitional commissions',
            TaxS: 'Income tax',
            TaxJ: 'resident tax',
            Account: 'deposit account',
            AccountName: 'account holder',    
            SponsorBot: 'This is the general commission for {name}.',
            SponsorTitle: 'Please check the details related to the general commission.',
            DateFormat: 'by {date} ',
            BasedTime: 'by {date}:00 AM',
            BasedTimeMastership: 'by {date}',
            Score: 'points earned',
            ScoreFormat: '{score}',
            SponsorTotal: 'total',
            OccurBot: 'These are the points and Masterships that {name} earned during the recent support payment settlement. If you want to see more detailed information, click the [View details of general commissions] button below.',
            AquPositon: 'acquired Mastership',
            OccurDetail: 'View additional general commission accrual history',
            Detail: 'View commission details',
            SaleList: 'Sales inquiry',
            Others: 'general commission in Other Periods',
            HoldPv: 'holding PV',
            PositonPayBot: "{name}'s current position is {position}. Please take a look at the Mastership details of the {recently Mastership Achived based date}.",
            PositionDay15: 'currently {name} is {position}<br>1st ~ 15t Check out mastership history.?',
            PositionDay31: 'currently {name} is {position}<br>16th ~ last day Check out mastership history?',
            MySales: 'own sales',
            PositionPayMore: 'See more Mastership',
            ShowSales: 'View sales',
            Income: 'commission details',
            NothingIncome: "I haven't received any recent commission. If you want to view the details of commission, click the [View more commission detßails] button below.",
            NoHuwon: 'Recently, {n}days have not smaller leg.',
            Sales: 'Sales', // 매출
            InvalidGrade: 'Unfortunately, there are no positions achieved.', 
            MastershipHistory: 'Check out your mastership history.',
            NoMastershipHistory: 'Oh, you have no mastership history.',

        }
    },
};
